import axios from "../utils/axios.wrapper";

export const uploadPhoto = async (formData) => {
  const { data } = await axios.post("/photo/upload", formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return data;
};

export const getPresignedUrl = async (photoId) => {
  const { data } = await axios.get(`/photo/presigned-url/${photoId}`);
  return data;
};

export const deletePhoto = async (photoId) => {
  const { data } = await axios.delete(`/photo/${photoId}`);
  return data;
};

export const updatePhoto = async (photoId, photoData) => {
  const { data } = await axios.put(`/photo/${photoId}`, photoData);
  return data;
};

// Helper function to get photo with presigned URL
export const getPhotoWithPresignedUrl = async (photo) => {
  if (!photo || !photo.id) {
    return photo;
  }

  try {
    const presignedData = await getPresignedUrl(photo.id);
    return {
      ...photo,
      presignedUrl: presignedData.presignedUrl || presignedData.url
    };
  } catch (error) {
    console.error(`Failed to get presigned URL for photo ${photo.id}:`, error);
    return photo; // Return original photo if presigned URL fails
  }
};

// Helper function to process multiple photos with presigned URLs
export const getPhotosWithPresignedUrls = async (photos) => {
  if (!photos || !Array.isArray(photos)) {
    return [];
  }

  try {
    const photosWithUrls = await Promise.all(
      photos.map(photo => getPhotoWithPresignedUrl(photo))
    );
    return photosWithUrls;
  } catch (error) {
    console.error('Failed to process photos with presigned URLs:', error);
    return photos; // Return original photos if processing fails
  }
};

export const setPrincipalPhoto = async (photoList, principalPhotoId) => {
  const payload = { PhotoList: photoList, PrincipalPhotoId: principalPhotoId };
  return axios.post("/photo/set-principal", payload);
};

export const softDeletePhoto = async (photoId) => {
  return axios.delete(`/photo/${photoId}`);
};

export const photoService = {
  uploadPhoto,
  getPresignedUrl,
  deletePhoto,
  updatePhoto,
  getPhotoWithPresignedUrl,
  getPhotosWithPresignedUrls,
  setPrincipalPhoto,
  softDeletePhoto,
};